import React, { useState, useEffect } from 'react'; // Make sure to import the CSS
import { useSearchParams } from 'react-router-dom';
import LocationForm from '../../../Component/Destination/Location';
import DestinationImage from '../../../Component/Destination/DestinationImage';
import DestinationContactForm from '../../../Component/Destination/DestinationContactForm';
import DestinationBasicInfo from '../../../Component/Destination/DestinationBasicInfo';

const DestinationForm = () => {
  const [searchParams] = useSearchParams();
  const [destinationUuid, setdestinationUuid] = useState('');
  const [activeTab, setActiveTab] = useState('basic');
  const [isViewMode, setIsViewMode] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [formData, setFormData] = useState({
    destinationName: '',
    displayName: '',
    destinationType: '',
    ownershipType: '',
    status: 'Active',
    verificationStatus: 'Pending Verification',
    shortDescription: '',
    fullDescription: '',
    highlights: '',
    category: '',
    subcategory: '',
    tags: ''
  });

  useEffect(() => {
    const uuidParam = searchParams.get('uuid');
    const modeParam = searchParams.get('mode');
    const tabParam = searchParams.get('tab');

    if (uuidParam) {
      setdestinationUuid(uuidParam);
    }

    setIsViewMode(modeParam === 'view');
    setIsEditMode(modeParam === 'edit');

    if (tabParam) {
      setActiveTab(tabParam);
    }
  }, [searchParams]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    // Handle form submission logic here
  };


  const tabs = [
    { id: 'basic', label: 'Basic Info' },
    { id: 'location', label: 'Location' },
    { id: 'images', label: 'Images' },
    { id: 'contact', label: 'Contact Info' },
  ];

  return (
    <div className="bg-white border rounded-xl border-slate-200">
      <div className="px-6 pt-6">
        <h1 className="text-xl font-bold text-slate-900">Destination Information</h1>

        {/* Tabs */}
        <div className="flex mt-4 border-b border-slate-200">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`px-4 py-3 mr-2 text-sm font-semibold border-b-2 -mb-px transition-colors ${
                activeTab === tab.id
                  ? 'text-brand-blue border-brand-blue'
                  : 'text-slate-500 border-transparent hover:text-slate-700'
              }`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Basic Info Tab Content */}
      {activeTab === 'basic' && (
        <div className="p-6">
          < DestinationBasicInfo destinationUuid={destinationUuid} setDestinationUuid={setdestinationUuid} 
          setActiveTab={setActiveTab} isViewMode={isViewMode} isEditMode={isEditMode}/>

        </div>
      )}

      {/* Location Tab */}
      {activeTab === 'location' && (
        <div className="p-6">
          <LocationForm destinationUuid={destinationUuid}
          setActiveTab={setActiveTab} isViewMode={isViewMode} isEditMode={isEditMode}/>
        </div>
      )}

      {/* Images Tab */}
      {activeTab === 'images' && (
        <div className="p-6">
          <DestinationImage destinationUuid={destinationUuid}
          setActiveTab={setActiveTab} activeTab={activeTab} isViewMode={isViewMode} isEditMode={isEditMode} />
        </div>
      )}

      {/* Contact Info Tab */}
      {activeTab === 'contact' && (
        <div className="p-6">
          < DestinationContactForm destinationUuid={destinationUuid}
          setActiveTab={setActiveTab} isViewMode={isViewMode} isEditMode={isEditMode} />
        </div>
      )}

      {/* Tickets Tab */}
      {activeTab === 'tickets' && (
        <div className="p-6">
          <p>Tickets tab content will go here</p>
        </div>
      )}
    </div>
  );
};

export default DestinationForm;
